import type { QuestionDefinition } from "@reno-estimator/core";
import { builtInsQuestion, flooringQuestion, lightingQuestion, paintingQuestion, trimQuestion, windowsDoorsQuestion } from "./interior-room-shared.js";

/** Entryway / Foyer (Phase 13A) - see rules/entryway-foyer.ts for the matching calculator. */
export const entrywayFoyerQuestions: QuestionDefinition[] = [
  flooringQuestion("entryway_foyer", 200, "entryway/foyer"),
  paintingQuestion("entryway_foyer", 210),
  trimQuestion("entryway_foyer", 220),
  lightingQuestion("entryway_foyer", 230, "A statement entry fixture is common scope for a foyer."),
  builtInsQuestion("entryway_foyer", 240, "What about a closet or bench?", "Custom closet/bench built-in"),
  windowsDoorsQuestion("entryway_foyer", 250, "Replacing the front door or adding windows?")
];
